import React from 'react';
export var Google = function Google() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4261 12.7113C21.4261 12.052 21.3669 11.418 21.257 10.8094H12.5V14.4061H17.504C17.2885 15.5683 16.6334 16.5531 15.6486 17.2124V19.5453H18.6536C20.4118 17.9266 21.4261 15.543 21.4261 12.7113Z",
    fill: "#4285F4",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 21.798C15.0105 21.798 17.1153 20.9654 18.6537 19.5453L15.6487 17.2124C14.8161 17.7703 13.7511 18.0999 12.5001 18.0999C10.0784 18.0999 8.02858 16.4643 7.29742 14.2666H4.19104V16.6756C5.72098 19.7144 8.8654 21.798 12.5001 21.798Z",
    fill: "#34A853",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29737 14.2666C7.11141 13.7087 7.00576 13.1128 7.00576 12.5C7.00576 11.8872 7.11141 11.2912 7.29737 10.7334V8.32434H4.191C3.56127 9.57957 3.20203 10.9996 3.20203 12.5C3.20203 14.0003 3.56127 15.4204 4.191 16.6756L7.29737 14.2666Z",
    fill: "#FBBC05",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 6.90007C13.8652 6.90007 15.0908 7.36919 16.0544 8.29054L18.7213 5.6237C17.111 4.12334 15.0063 3.202 12.5001 3.202C8.8654 3.202 5.72098 5.28559 4.19104 8.32435L7.29742 10.7334C8.02858 8.53567 10.0784 6.90007 12.5001 6.90007Z",
    fill: "#EA4335",
    stroke: "none"
  }));
};